import { loadInfraHubRuntimeConfig } from '../runtime/runtime-config.js';
import { InfraHubOAuthClient } from './oauth-client.js';

let clientPromise: Promise<InfraHubOAuthClient> | undefined;

export function getLiveOAuthClient(): Promise<InfraHubOAuthClient> {
  clientPromise ??= loadInfraHubRuntimeConfig().then((config) => new InfraHubOAuthClient(config));
  return clientPromise;
}
